import {useEffect, useState} from "react";

export function useFetch(url) {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
            const json = await response.json();
            const dataWithDisplay = json.filter(track => track.display !== false);
            let reversedData = [...dataWithDisplay]
            .reverse()
            .filter(track => !track.release_date || new Date(track.release_date) <= new Date())
            setData(reversedData);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    
    fetchData();
},[url])

    return [data, loading, error];
}

export function useFetchLast3(url) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`);
        const json = await response.json();
        const last3 = [...json]
      .reverse()
      .filter(track => track.audio)
      .filter(track => !track.release_date || new Date(track.release_date) <= new Date())
      .slice(0, 3);
        
        setData(last3);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return [data, loading, error];
}